<template>
  <div class="custom-ui-modal-wrapper" v-if="display">
    <div class="custom-ui-modal">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import type { IUIModal } from '@/types/Components'
  import { watch } from 'vue'

  const { display = false } = defineProps<IUIModal>()

  watch(
    () => display,
    (val: boolean) => {
      if (val) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'auto'
      }
    },
  )
</script>

<style lang="scss">
  .custom-ui-modal-wrapper {
    @include flexible($direction: column, $align: center, $justify: center);
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2000;
    padding: 1rem;
    background-color: rgba(0, 0, 0, 0.2);
    .custom-ui-modal {
      @include flexible($direction: column, $align: center, $justify: center);

      width: 100%;
    }
    .modal-wrapper {
      background-color: $white;
      @include flexible($direction: column, $justify: space-between);
      border-radius: 5px;
      @include media(xs, sm, md) {
        width: 100% !important;
        height: 100%;
      }
    }
    .modal-header {
      width: 100%;
      height: 3.5rem;
      padding: 0 1rem;
      background-color: #f7f7f7;
      @include flexible($justify: space-between, $align: center);
      border-radius: 5px 5px 0 0;
    }
    .modal-tabs {
      width: 100%;
      @include flexible($align: center);
      color: $textColor;
      border-bottom: 1px solid $border-color;
      .tab-item {
        padding: 0.5rem 1rem;
        cursor: pointer;
        &.active {
          border-bottom: 1px solid $textColor;
        }
        &.disabled {
          color: $disabled;
          cursor: not-allowed;
        }
      }
    }
    .modal-body {
      padding: 1rem;
      @include flexible($direction: column, $align: center);
      height: calc(100% - 7rem);
      width: 100%;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 6px;
        background-color: #fff;
      }
      &::-webkit-scrollbar-thumb:vertical {
        background-color: $textColor;
        border-radius: 10px;
      }

      .modal-row {
        width: 100%;
        @include flexible($align: flex-end);
      }
      .modal-column {
        width: 100%;
        @include flexible($direction: column, $align: center);
      }
      .row-title {
        width: 100%;
        min-width: 100%;
        @include column-label($margin: 0.5rem);
      }
    }
    .modal-footer {
      width: 100%;
      height: 3.5rem;
      padding: 0 1rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      border-radius: 0 0 5px 5px;
      border-top: 1px solid $border-color;
      gap: 0.5rem;
    }
  }
</style>
